import { Badge, Button, Flex, Image } from '@mantine/core'
import './AcademicLibraryPreview.css'
import { IconFileMusic, IconFileTypeHtml, IconFileTypePdf, IconFileTypePpt, IconLink, IconNotebook, IconVideo } from '@tabler/icons-react'
import { useContext } from 'react'
import AcademicContext from '../../../../contexts/AcademicContext'


const CONTENT_TYPE_ENUM = {
   'article': "artículo",
   'video': "video",
   'audio': "audio",
   'ebook': "ebook",
   'pdf': "pdf",
   'presentation': "presentación",
   'link': "enlace",
}

const CONTENT_FORMAT_ENUM = {
   'mp4': <IconVideo />,
   'mp3': <IconFileMusic />,
   'pdf': <IconFileTypePdf />,
   'epub': <IconNotebook />,
   'pptx': <IconFileTypePpt />,
   'html': <IconFileTypeHtml />,
   'link': <IconLink />
}

export default function AcademicLibraryPreview({ form }) {
   const { specialtiesOptions } = useContext(AcademicContext)
   const values = form.form.values

   const mapContentType = (value) => {
      if (!value) return ""

      return CONTENT_TYPE_ENUM?.[value.toLowerCase()] || value
   }

   const mapContentFormat = (value) => {
      if (!value) return ""

      return CONTENT_FORMAT_ENUM?.[value.toLowerCase()] || value
   }

   const mapTags = (tag, idx) => {
      const isSpecialty = specialtiesOptions.find(item => item.value === tag)?.label
      if (isSpecialty) { return <Badge key={idx}>{specialtiesOptions.find(item => item.value === tag)?.label}</Badge> }
      return <Badge key={idx}>{tag}</Badge>
   }

   return (
      <section className='AcademicLibraryPreivew-main-container'>
         <Flex gap={16} align='start' justify='center' h='100%' w='100%'>
            <article className='Library-content-container'>
               <Image
                  className='Library-content--image' alt={`portada de ${values?.title}`}
                  src={values?.image}
                  fallbackSrc="https://placehold.co/600x400?text=Placeholder"
               />
               <h3 className='Library-content--title--overlflow'>{values?.title}</h3>
            </article>

            <div className='Library-content-modal-wrapper'>
               <Image
                  fallbackSrc="https://placehold.co/600x400?text=Placeholder"
                  className='Library-content--image Library-content--modal-image' alt={`portada de ${values?.title}`}
                  src={values?.image}
               />


               <div className='Library-content-modal-information-wrapper'>
                  {values?.tags && values?.tags?.length > 0 && values?.tags?.map((tag, idx) => (
                     mapTags(tag, idx)
                  ))}
                  {values?.lang && <Badge >{values.lang}</Badge>}
               </div>

               <h3 className='Library-content--title'>{values?.title}</h3>
               {values?.description &&
                  <p className='Library-content--description'>{values?.description}</p>
               }

               <hr style={{ backgroundColor: '#d3d3d3', width: '100%', height: "1px" }} />

               <div className='Library-content-features-wrapper'>
                  {values?.author &&
                     <h4 className='Library-content--featureItem'>
                        <strong>Autor & cita: </strong>{values?.author}
                     </h4>
                  }
                  {values?.type &&
                     <h4 className='Library-content--featureItem'>
                        <strong>Tipo: </strong>{mapContentType(values?.type)}
                     </h4>
                  }
                  {values?.format &&
                     <h4 className='Library-content--featureItem'>
                        <strong>Formato: </strong>
                        <span style={{ display: 'flex', alignItems: 'center' }}
                        >
                           {mapContentFormat(values?.format)} {values?.format}
                        </span>
                     </h4>
                  }
               </div>

               <Button
                  type='button'
                  color='#e1568b'
               >
                  Acceder al contenido
               </Button>

            </div>
         </Flex>
      </section>
   )
}
